import React from 'react';
import PropTypes from 'prop-types';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import ModalLayout from '../ModalLayout';

export default function DeleteWidgetModalDisplay(props) {
  const {
    isOpen,
    toggleModal,
    handleWidgetDelete,
    error,
    deleteRequestPending,
  } = props;
  return (
    <ModalLayout
      desktopHeight="unset"
      isOpen={isOpen}
      toggleModal={toggleModal}
    >
      <ModalHeader className="border-0 modal-title-text" toggle={toggleModal}>
        Delete Smart Tile?
      </ModalHeader>
      <ModalBody className="container-fluid py-0">
        <div className="row justify-content-center">
          <p className="col-12 col-lg-10 text-left modal-supplemental-text">
            Deleting this smart tile will permanently remove it from this asset,
            and all other assets with the same Asset Model.
          </p>
        </div>
        <div className="row justify-content-center">
          <p className="col-12 col-lg-10 text-left modal-supplemental-text">
            Configuration data associated with this smart tile will be lost, but
            you can create the same smart tile with the same signals at any time
            if you&#8217;d like.
          </p>
        </div>
        <div className="row justify-content-center">
          <p className="col-12 col-lg-10 text-danger text-right">{error}</p>
        </div>
      </ModalBody>
      <ModalFooter className="border-0">
        <button
          className="btn btn-outline-secondary py-0 px-3 ml-4"
          onClick={toggleModal}
        >
          Cancel
        </button>
        <button
          className="btn btn-danger py-0 px-3"
          onClick={handleWidgetDelete}
        >
          {deleteRequestPending ? (
            <FontAwesomeIcon icon={faCircleNotch} spin size="lg" />
          ) : (
            'Yes, Delete'
          )}
        </button>
      </ModalFooter>
      <style jsx>{`
        .btn {
          font-size: 0.9rem;
        }
        .description-container {
          font-size: 0.75rem;
        }
        @media (min-width: 768px) {
          .description-container {
            font-size: 1rem;
          }
        }
      `}</style>
    </ModalLayout>
  );
}

DeleteWidgetModalDisplay.propTypes = {
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  handleWidgetDelete: PropTypes.func,
  error: PropTypes.string,
  deleteRequestPending: PropTypes.bool,
};
